const configWebRoute = {
  // PDPA ROUTE
  PRIVACY_NOTICE_KEY: "privacy-notice-key",
  TERMS_OF_USE_KEY: "terms-of-use-key",
  COOKIE_NOTICE_KEY: "cookie-notice-key",
  TAKEDOWN_NOTICE_KEY: "takedown-notice-key",

  PRIVACY_NOTICE_FOR_CUSTOMERS_KEY: "privacy-notice-for-customers-key",

  PDPA_NEW_PAGE_KEY: "pdpa-new-page-key",
  PDPA_NEW_PAGE_DETAIL_KEY: "pdpa-new-page-detail-key",

  CORPORATE_GOVERNANCE_KEY: "corporate-governance-key",

  EXECUTIVES_AND_BOARDS: "executives-and-boards-key",
  EXECUTIVES_AND_BOARDS_EXECUTIVES: "executives-and-boards-executives-key",
  EXECUTIVES_AND_BOARDS_BOARDS: "executives-and-boards-boards-key",

  AWARDS_AND_RECOGNITION: "awards-and-recognition-key",
  ORGANIZATION_CHART: "organization-chart-key",
  HISTORY: "history-key",

  HERO_BANNER: "hero-banner-key",
  NEW_PAGE: "new-page-key",
  NEW_PAGE_DETAIL: "new-page-detail-key",
  NEW_PAGE_LINK: "new-page-link-key",
  BUSINESS_PURPOSE: "business-purpose-key",
  BUSINESS_PURPOSE_PAGE: "business-purpose-page-key",
  CONTENT_BANNER: "content-banner-key",
  MENU_MANAGEMENT: "menu-management-key",
  WHAT_WE_DO: "what-we-do-key",
  Highlight_CARD: "what-we-do-card-key",
  WHAT_WE_DO_CARD_BANNER: "what-we-do-card-banner-key",
  WHAT_WE_DO_CARD_INFO: "what-we-do-card-info-key",

  SUSTAINABILITY: "sustainability-key",
  SUSTAINABILITY_SLIDE: "sustainability-slide-mini-key",
  SUSTAINABILITY_SLIDE2: "sustainability-slide2-mini-key",
  SUSTAINABILITY_SLIDE_MINI: "sustainability-slide-key",
  ESG_4_PLUS: "esg-4-plus-key",
  ESG_4_PLUS_ORIGINAL: "esg-4-plus-original-key",
  ESG_IN_ACTION: "esg-in-action-key",
  FLAGSHIP_PROJECT: "flagship-project-key",
  FLAGSHIP_SUB_SESSION: "flagship-sub-session-key",
  FLAGSHIP_PROJECT_DETAIL: "flagship-project-detail-key",
  FLAGSHIP_PROJECT_CATE: "flagship-project-cate-key",
  SUSTAINABILITY_PERFORMANCE: "sustainability-performance-key",
  NEWS_AND_UPDATE: "news-and-update-key",
  NEWS_AND_UPDATE_SETTING: "news-and-update-setting-key",
  PUBLICATION: "publication-key",
  PUBLICATION_DETAIL: "publication-detail-key",
  GALLERY: "gallery-key",
  GALLERY_DETAIL: "gallery-detail-key",
  GLOBAL_PRESENSE: "global-presense-key",
  GLOBAL_PRESENSE_DETAIL: "global-detail-presense-key",
  COMPANY_PROFILE: "company-profile-key",
  COMPANY_PROFILE_DETAIL: "company-profile-detail-key",
  NEWS_AND_UPDATE_DETAIL: "news-and-update-detail-key",
  LEADER_THOUGHTS: "leader-thoughts-key",
  NEWS_VDO: "news-vdo-key",
  NEWS_TAG: "news-tag-key",
  ORGANIZATION_POSSIBILITY: "organization-possibilities-key",
  ORGANIZATION_POSSIBILITY_PROJECT: "organization-possibilities-project-key",

  REGION_LINK: "region-link-key",
  CONTACT_US: "contact-us-key",
  HOME: "home-key",
  PRODUCT_DIRECTORY: "product-directory-key",
  OUR_BRANDS: "our-brand-key",
  OUR_BRANDS_CATEGORY: "our-brand-category-key",
  SITEMAP: "sitemap-key",
  SEARCH_RESULT: "search-result-key",
  SEARCH_TAG: "search-tag-key",

  COVER_MANAGEMENT: "cover-management-key",
}

export default configWebRoute
